var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form", staticClass: "steps-form" },
    [
      _c("v-divider"),
      _vm.anyError
        ? _c("v-alert", {
            staticClass: "mb-0",
            attrs: { type: "error", color: "red", rounded: "0" },
            domProps: { innerHTML: _vm._s(_vm.anyError) },
          })
        : _vm._e(),
      _vm.unsavedFound
        ? _c(
            "v-alert",
            {
              staticClass: "mb-0",
              attrs: { dismissible: "", type: "success", rounded: "0" },
              on: {
                close: function ($event) {
                  this.unsavedFound = false
                },
              },
            },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "grow" }, [
                    _vm._v(
                      " Найдены несохраненные данные редактирования. Загрузить? "
                    ),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "shrink" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white", text: "", elevation: "0" },
                          on: { click: _vm.loadUnsaved },
                        },
                        [_vm._v("Загрузить")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-tabs",
        {
          staticClass: "steps-form__menu",
          attrs: { vertical: "", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { attrs: { href: "#upload" } }, [
            _vm._v("Загрузка файлов"),
          ]),
          _c(
            "v-tab",
            { attrs: { href: "#grid", disabled: _vm.isUploading } },
            [
              !_vm.isGridValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Параметры сетки "),
            ],
            1
          ),
          _c(
            "v-tab",
            {
              attrs: {
                href: "#shape",
                disabled: _vm.isUploading || !_vm.gridHasData,
              },
            },
            [
              !_vm.isShapeValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Форма залежи "),
            ],
            1
          ),
          _c(
            "v-tab",
            {
              attrs: {
                href: "#wells",
                disabled: _vm.isUploading || !_vm.gridHasData,
              },
            },
            [
              !_vm.isWellsValid || !_vm.isConnectionsValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Скважины "),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#swso", disabled: _vm.isUploading } },
            [
              !_vm.isSwSoValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Начальные S"),
              _c("sub", [_vm._v("w")]),
              _vm._v(" и S"),
              _c("sub", [_vm._v("o")]),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#p", disabled: _vm.isUploading } },
            [
              !_vm.isPValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Начальное Р"),
              _c("sub", [_vm._v("пл")]),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#fluid", disabled: _vm.isUploading } },
            [
              !_vm.isFluidValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Свойства флюидов "),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#ofp", disabled: _vm.isUploading } },
            [
              !_vm.isOfpValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" ОФП "),
            ],
            1
          ),
          _c(
            "v-tab",
            {
              attrs: {
                href: "#rock",
                disabled: _vm.isUploading || !_vm.gridHasData,
              },
            },
            [
              !_vm.isRockValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" Свойства породы "),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#injectionData", disabled: _vm.isUploading } },
            [
              !_vm.isInjectionDataValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" История разработки "),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#historyData", disabled: _vm.isUploading } },
            [
              !_vm.isHistoryDataValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" История добычи "),
            ],
            1
          ),
          _c(
            "v-tab",
            { attrs: { href: "#bhpData", disabled: _vm.isUploading } },
            [
              !_vm.isBhpDataValid
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ])
                : _vm._e(),
              _vm._v(" История давлений "),
            ],
            1
          ),
          _c("v-spacer"),
          _vm.allErrors && _vm.allErrors.length > 0
            ? _c(
                "v-menu",
                {
                  attrs: { top: "", "offset-y": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-4",
                                    attrs: {
                                      color: "red",
                                      dark: "",
                                      elevation: "0",
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm._v(" Ошибки "),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "px-1 ml-2",
                                    attrs: {
                                      color: "white",
                                      "text-color": "red",
                                      small: "",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.allErrors.length))]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3965731222
                  ),
                },
                [
                  _c(
                    "v-list",
                    _vm._l(_vm.allErrors, function (error, index) {
                      return _c(
                        "v-list-item",
                        { key: index, attrs: { color: "red" } },
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(error.error)),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: { text: "", elevation: "0", disabled: "" },
                },
                [_vm._v("Ошибок нет")]
              ),
          _c(
            "v-tabs-items",
            {
              staticClass: "allow-overflow",
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c("step", {
                attrs: {
                  "tab-code": "upload",
                  title: "Загрузка файлов",
                  value: _vm.oneStepFiles,
                  error: _vm.oneStepFileError,
                  "is-valid": _vm.isValid,
                  "is-uploading": _vm.isUploading,
                  "enable-upload": true,
                  "show-files": true,
                  description:
                    "Вы можете выбрать один или несколько файлов с описанием модели в формате Eclipse",
                },
                on: { input: _vm.setOneStepFiles },
                scopedSlots: _vm._u(
                  [
                    !_vm.isUploading
                      ? {
                          key: "content",
                          fn: function () {
                            return [
                              _c(
                                "v-radio-group",
                                {
                                  model: {
                                    value: _vm.uploadType,
                                    callback: function ($$v) {
                                      _vm.uploadType = $$v
                                    },
                                    expression: "uploadType",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      value: "file",
                                      label: "Загрузить данные",
                                    },
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      value: "manual",
                                      label: "Ввести вручную",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        }
                      : {
                          key: "content",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                    (!_vm.isUploading && _vm.uploadType === "manual") ||
                    _vm.isUploading
                      ? {
                          key: "upload",
                          fn: function () {
                            return [_c("span")]
                          },
                          proxy: true,
                        }
                      : null,
                    !_vm.isUploading && _vm.uploadType === "manual"
                      ? {
                          key: "extra",
                          fn: function () {
                            return [
                              _c(
                                "v-btn",
                                {
                                  attrs: { elevation: "0", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.tab = "grid"
                                    },
                                  },
                                },
                                [_vm._v("Ввести данные")]
                              ),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
              _c("step", {
                attrs: {
                  "tab-code": "grid",
                  title: "Параметры сетки",
                  "input-has-data": _vm.gridHasData,
                  "is-valid": _vm.isGridValid,
                  "is-uploading": _vm.isUploading,
                  description: "Файл с расширением .DATA",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          { staticClass: "grid-table mb-4" },
                          [
                            _c(
                              "v-row",
                              { staticClass: "grid-header" },
                              [
                                _c("v-col", [_vm._v("Размерность")]),
                                _c("v-col", [_vm._v("Кол-во ячеек")]),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_grid_size_x",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                        disabled: _vm.isParsed,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [_vm._v("X")]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("м")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.gridCellSize[0],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gridCellSize, 0, $$v)
                                        },
                                        expression: "gridCellSize[0]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_grid_x",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                        disabled: _vm.isParsed,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [_vm._v("По X")]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.gridSize[0],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gridSize, 0, $$v)
                                        },
                                        expression: "gridSize[0]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_grid_size_y",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        type: "number",
                                        min: "0",
                                        disabled: _vm.isParsed,
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [_vm._v("Y")]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("м")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.gridCellSize[1],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gridCellSize, 1, $$v)
                                        },
                                        expression: "gridCellSize[1]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_grid_y",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        type: "number",
                                        min: "0",
                                        disabled: _vm.isParsed,
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [_vm._v("По Y")]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.gridSize[1],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gridSize, 1, $$v)
                                        },
                                        expression: "gridSize[1]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_grid_size_z",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        type: "number",
                                        min: "0",
                                        disabled: _vm.isParsed,
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [_vm._v("Z")]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("м")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.gridCellSize[2],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gridCellSize, 2, $$v)
                                        },
                                        expression: "gridCellSize[2]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_grid_z",
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        type: "number",
                                        min: "0",
                                        disabled: _vm.isParsed,
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [_vm._v("По Z")]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.gridSize[2],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gridSize, 2, $$v)
                                        },
                                        expression: "gridSize[2]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.gridFiles,
                  callback: function ($$v) {
                    _vm.gridFiles = $$v
                  },
                  expression: "gridFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "shape",
                  title: "Форма залежи",
                  "is-valid": _vm.isShapeValid,
                  "is-uploading": _vm.isUploading,
                  description:
                    "Данные берутся из куба ACTNUM файлов гидродинамического симулятора",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          {
                            ref: "wrapper",
                            staticClass: "fill-height d-flex flex-column",
                          },
                          [
                            _c(
                              "h2",
                              { staticClass: "page-title page-title__primary" },
                              [_vm._v("Форма залежи")]
                            ),
                            _c("p", [
                              _vm._v(
                                "Данные берутся из куба ACTNUM файлов гидродинамического симулятора"
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "grid-wrapper" },
                              [
                                _vm.tab === "shape"
                                  ? _c("grid", {
                                      attrs: {
                                        "problem-id": _vm.item.id,
                                        problem: _vm.item,
                                        "input-size": _vm.gridSize,
                                        "input-cell-size": _vm.gridCellSize,
                                        "input-show-mesh": true,
                                        "is-parsed": _vm.isParsed,
                                        "grid-mesh-file": _vm.gridMeshFile,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.shapeFiles,
                  callback: function ($$v) {
                    _vm.shapeFiles = $$v
                  },
                  expression: "shapeFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "wells",
                  "is-valid": _vm.isWellsValid && _vm.isConnectionsValid,
                  "is-uploading": _vm.isUploading,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c("wells", {
                          ref: "wells",
                          attrs: {
                            "grid-size": _vm.gridSize,
                            "grid-cell-size": _vm.gridCellSize,
                            "grid-files": _vm.allFilesText,
                            "grid-properties": _vm.gridProperties,
                            connections: _vm.editConnections,
                            nodes: _vm.editNodes,
                            "is-parsed": _vm.isParsed,
                            problem: _vm.unsavedProblem,
                            "input-constants": _vm.allConstants,
                          },
                          on: {
                            deleteWell: _vm.deleteWell,
                            "input-connections": _vm.setConnections,
                            connections: function (method) {
                              return _vm.updateConnections(method, true)
                            },
                            active: function (wellId) {
                              return (_vm.activeWellId = wellId)
                            },
                            error: _vm.setConnectionsError,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "grid",
                              fn: function (ref) {
                                var wc = ref.wc
                                return [
                                  _c("grid", {
                                    attrs: {
                                      "problem-id": _vm.unsavedProblem.id,
                                      "input-wells": _vm.wells,
                                      "input-show-wells": true,
                                      "input-show-mesh": false,
                                      "input-show-connections": true,
                                      connections: _vm.editConnections,
                                      "injection-data": _vm.injectionData,
                                      nodes: _vm.editNodes,
                                      "is-parsed": _vm.isParsed,
                                      "grid-mesh-file": _vm.gridMeshFile,
                                      "active-well-id": _vm.activeWellId,
                                      editable: true,
                                      "show-extra-menu": true,
                                    },
                                    on: {
                                      clickWell: _vm.editWell,
                                      addWell: _vm.addWellByCoords,
                                      deleteWell: _vm.deleteWell,
                                      addConnection: _vm.addConnection,
                                      deleteConnection: _vm.deleteConnection,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "extraMenu",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-card",
                                                [
                                                  _c("v-card-text", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-row mb-4 w-100",
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn-toggle",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  elevation:
                                                                    "0",
                                                                  dark: "",
                                                                  loading:
                                                                    wc.isConnectionsLoading,
                                                                },
                                                                on: {
                                                                  click:
                                                                    wc.loadConnections,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Перестроить соединения (" +
                                                                    _vm._s(
                                                                      wc.activeBuilderTitle
                                                                    ) +
                                                                    ") "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-menu",
                                                              {
                                                                attrs: {
                                                                  "offset-y":
                                                                    "",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "activator",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          var attrs =
                                                                            ref.attrs
                                                                          return [
                                                                            _c(
                                                                              "v-btn",
                                                                              _vm._g(
                                                                                _vm._b(
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "primary",
                                                                                        elevation:
                                                                                          "0",
                                                                                        dark: "",
                                                                                        icon: "",
                                                                                      },
                                                                                  },
                                                                                  "v-btn",
                                                                                  attrs,
                                                                                  false
                                                                                ),
                                                                                on
                                                                              ),
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-cog"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list",
                                                                  _vm._l(
                                                                    wc.connectionBuilderTypes,
                                                                    function (
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "v-list-item",
                                                                        {
                                                                          key: item.value,
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                wc.connectionBuilderType =
                                                                                  item.value
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.text
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        wc.showConnectionsUpdate
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex text--disabled ml-4 align-center",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Возможно, соединения следует обновить "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-row mb-4 w-100",
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn-toggle",
                                                          {
                                                            staticClass:
                                                              "w-100",
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  elevation:
                                                                    "0",
                                                                  outlined: "",
                                                                  loading:
                                                                    wc.imaginaryLoading,
                                                                },
                                                                on: {
                                                                  click:
                                                                    wc.addImaginaryWells,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Добавить мнимые скважины (" +
                                                                    _vm._s(
                                                                      wc.activeImaginaryBuilderTitle
                                                                    ) +
                                                                    ", " +
                                                                    _vm._s(
                                                                      wc.imaginaryCount
                                                                    ) +
                                                                    " шт) "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-menu",
                                                              {
                                                                attrs: {
                                                                  "offset-y":
                                                                    "",
                                                                  "close-on-content-click": false,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "activator",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          var attrs =
                                                                            ref.attrs
                                                                          return [
                                                                            _c(
                                                                              "v-btn",
                                                                              _vm._g(
                                                                                _vm._b(
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "primary",
                                                                                        elevation:
                                                                                          "0",
                                                                                        dark: "",
                                                                                        icon: "",
                                                                                      },
                                                                                  },
                                                                                  "v-btn",
                                                                                  attrs,
                                                                                  false
                                                                                ),
                                                                                on
                                                                              ),
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-cog"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _c(
                                                                  "v-card",
                                                                  [
                                                                    _c(
                                                                      "v-card-text",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                type: "number",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  wc.imaginaryCount,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      wc,
                                                                                      "imaginaryCount",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "wc.imaginaryCount",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-list",
                                                                      _vm._l(
                                                                        wc.imaginaryBuilderTypes,
                                                                        function (
                                                                          item
                                                                        ) {
                                                                          return _c(
                                                                            "v-list-item",
                                                                            {
                                                                              key: item.value,
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    wc.imaginaryBuilderType =
                                                                                      item.value
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.text
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-row mb-4 w-100",
                                                      },
                                                      [
                                                        _c(
                                                          "v-menu",
                                                          {
                                                            attrs: {
                                                              "offset-y": "",
                                                              "close-on-content-click": false,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var on =
                                                                      ref.on
                                                                    var attrs =
                                                                      ref.attrs
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    "primary",
                                                                                  elevation:
                                                                                    "0",
                                                                                  outlined:
                                                                                    "",
                                                                                },
                                                                            },
                                                                            "v-btn",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " Копировать скважины из другой задачи "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.showCopyWellsMenu,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.showCopyWellsMenu =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "showCopyWellsMenu",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-card",
                                                              [
                                                                _c(
                                                                  "v-list",
                                                                  _vm._l(
                                                                    _vm.wellCopyItems,
                                                                    function (
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "v-list-item",
                                                                        {
                                                                          key: item.id,
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.copyWells(
                                                                                  wc,
                                                                                  item
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item
                                                                                    .problem
                                                                                    .name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-row",
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              block: "",
                                                              elevation: "0",
                                                              outlined: "",
                                                              loading:
                                                                wc.recalcLoading,
                                                            },
                                                            on: {
                                                              click:
                                                                wc.recalcAll,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Пересчитать все "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.wells,
                            callback: function ($$v) {
                              _vm.wells = $$v
                            },
                            expression: "wells",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.wellFiles,
                  callback: function ($$v) {
                    _vm.wellFiles = $$v
                  },
                  expression: "wellFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "swso",
                  title: "Начальные S<sub>w</sub> и S<sub>o</sub>",
                  "is-valid": _vm.isSwSoValid,
                  "is-uploading": _vm.isUploading,
                  description:
                    "Берутся из куба SWATINIT гидродинамического симулятора, либо из секции SWOF",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          { staticClass: "mb-8 input-fields" },
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_sw",
                                      attrs: {
                                        dense: "",
                                        hint: "Неуменьшаемая водонасыщенность",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        max: "1",
                                        step: "0.1",
                                        rules: _vm.validationRules.zeroToOne,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("S"),
                                                _c("sub", [_vm._v("w")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["sw"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "sw",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['sw']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_so",
                                      attrs: {
                                        dense: "",
                                        hint: "Остаточная водонасыщенность",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        max: "1",
                                        step: "0.1",
                                        rules: _vm.validationRules.zeroToOne,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("S"),
                                                _c("sub", [_vm._v("o")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["so"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "so",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['so']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.swsoFiles,
                  callback: function ($$v) {
                    _vm.swsoFiles = $$v
                  },
                  expression: "swsoFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "p",
                  title: "Начальное Р<sub>пл</sub>",
                  "is-valid": _vm.isPValid,
                  "is-uploading": _vm.isUploading,
                  description:
                    "Значение берется из ключевого слова EQUIL раздела SOLUTION",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          { staticClass: "mb-8 input-fields" },
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_p",
                                      attrs: {
                                        dense: "",
                                        hint: "Давление пласта",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("P"),
                                                _c("sub", [_vm._v("пл")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("бар")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["p"],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.inputConstants, "p", $$v)
                                        },
                                        expression: "inputConstants['p']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_dd",
                                      attrs: {
                                        dense: "",
                                        hint: "Глубина приведения",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("D"),
                                                _c("sub", [_vm._v("d")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("м")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["dd"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "dd",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['dd']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.pFiles,
                  callback: function ($$v) {
                    _vm.pFiles = $$v
                  },
                  expression: "pFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "fluid",
                  title: "Свойства флюидов",
                  "is-valid": _vm.isFluidValid,
                  "is-uploading": _vm.isUploading,
                  description:
                    "Значение берутся из секций PVTO, PVDO, PVCO, PVCDO, PVTW" +
                    (_vm.needDensity ? ", DENSITY" : ""),
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          { staticClass: "mb-8 input-fields" },
                          [
                            _c(
                              "h3",
                              { staticClass: "page-title page-title__primary" },
                              [_vm._v("Вода")]
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_mu_w",
                                      attrs: {
                                        dense: "",
                                        hint: "Вязкость воды",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("μ"),
                                                _c("sub", [_vm._v("W")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("мПа/сек")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["mu_w"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "mu_w",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['mu_w']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_cw",
                                      attrs: {
                                        dense: "",
                                        hint: "Сжимаемость воды",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("c"),
                                                _c("sub", [_vm._v("W")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._v("бар"),
                                                  _c("sup", [_vm._v("-1")]),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["cw"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "cw",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['cw']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.needDensity
                              ? _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-text-field", {
                                          ref: "input_rho_w_sc",
                                          attrs: {
                                            dense: "",
                                            hint: "Плотность воды при стандартных условиях",
                                            "persistent-hint": "",
                                            type: "number",
                                            min: "0",
                                            rules: _vm.validationRules.gtZero,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend",
                                                fn: function () {
                                                  return [
                                                    _c("p", [
                                                      _vm._v("ρ"),
                                                      _c("sub", [_vm._v("W")]),
                                                      _c("sup", [_vm._v("ст")]),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "append-outer",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v("кг/м"),
                                                        _c("sup", [
                                                          _vm._v("3"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1920392711
                                          ),
                                          model: {
                                            value:
                                              _vm.inputConstants["rho_w_sc"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputConstants,
                                                "rho_w_sc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "inputConstants['rho_w_sc']",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.needDensity
                              ? _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-text-field", {
                                          ref: "input_rho_w",
                                          attrs: {
                                            dense: "",
                                            hint: "Плотность воды в условиях пласта",
                                            "persistent-hint": "",
                                            type: "number",
                                            min: "0",
                                            rules: _vm.validationRules.gtZero,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend",
                                                fn: function () {
                                                  return [
                                                    _c("p", [
                                                      _vm._v("ρ"),
                                                      _c("sub", [_vm._v("W")]),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "append-outer",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v("кг/м"),
                                                        _c("sup", [
                                                          _vm._v("3"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            595529537
                                          ),
                                          model: {
                                            value: _vm.inputConstants["rho_w"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputConstants,
                                                "rho_w",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "inputConstants['rho_w']",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "page-title page-title__primary mt-8",
                              },
                              [_vm._v("Нефть")]
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_mu_o",
                                      attrs: {
                                        dense: "",
                                        hint: "Вязкость нефти",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("μ"),
                                                _c("sub", [_vm._v("O")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("мПа/сек")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["mu_o"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "mu_o",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['mu_o']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_co",
                                      attrs: {
                                        dense: "",
                                        hint: "Сжимаемость нефти",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("c"),
                                                _c("sub", [_vm._v("O")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._v("бар"),
                                                  _c("sup", [_vm._v("-1")]),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["co"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "co",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['co']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.needDensity
                              ? _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-text-field", {
                                          ref: "input_rho_o_sc",
                                          attrs: {
                                            dense: "",
                                            hint: "Плотность нефти при стандартных условиях",
                                            "persistent-hint": "",
                                            type: "number",
                                            min: "0",
                                            rules: _vm.validationRules.gtZero,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend",
                                                fn: function () {
                                                  return [
                                                    _c("p", [
                                                      _vm._v("ρ"),
                                                      _c("sub", [_vm._v("O")]),
                                                      _c("sup", [_vm._v("ст")]),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "append-outer",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v("кг/м"),
                                                        _c("sup", [
                                                          _vm._v("3"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            4153884959
                                          ),
                                          model: {
                                            value:
                                              _vm.inputConstants["rho_o_sc"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputConstants,
                                                "rho_o_sc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "inputConstants['rho_o_sc']",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.needDensity
                              ? _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-text-field", {
                                          ref: "input_rho_o",
                                          attrs: {
                                            dense: "",
                                            hint: "Плотность нефти в условиях пласта",
                                            "persistent-hint": "",
                                            type: "number",
                                            min: "0",
                                            rules: _vm.validationRules.gtZero,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend",
                                                fn: function () {
                                                  return [
                                                    _c("p", [
                                                      _vm._v("ρ"),
                                                      _c("sub", [_vm._v("O")]),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "append-outer",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v("кг/м"),
                                                        _c("sup", [
                                                          _vm._v("3"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            896428633
                                          ),
                                          model: {
                                            value: _vm.inputConstants["rho_o"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputConstants,
                                                "rho_o",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "inputConstants['rho_o']",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.fluidFiles,
                  callback: function ($$v) {
                    _vm.fluidFiles = $$v
                  },
                  expression: "fluidFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "ofp",
                  title: "Относительные фазовые проницаемости",
                  "is-valid": _vm.isOfpValid,
                },
                scopedSlots: _vm._u([
                  {
                    key: "description",
                    fn: function () {
                      return [
                        _c("p", [
                          _vm._v(
                            "Начальные значения коэффициентоц уравнений ОФП: a, n"
                          ),
                          _c("sub", [_vm._v("o")]),
                          _vm._v(", n"),
                          _c("sub", [_vm._v("w")]),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Значения этих коэффициентов будут изменяться в ходе адаптации. Конечные значения можно будет посмотреть в результатах расчета задачи."
                          ),
                        ]),
                        _c(
                          "p",
                          [
                            _c("vue-mathjax", {
                              attrs: {
                                formula: "$k_{rw}(S_w)=a \\cdot S_w^{n_w}$",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "p",
                          [
                            _c("vue-mathjax", {
                              attrs: { formula: "$k_{ro}(S_w)=S_w^{n_o}$" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c("ofp", {
                          attrs: {
                            siw: _vm.inputConstants["sw"],
                            sor: _vm.inputConstants["so"],
                          },
                          model: {
                            value: _vm.ofpConstants,
                            callback: function ($$v) {
                              _vm.ofpConstants = $$v
                            },
                            expression: "ofpConstants",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("step", {
                attrs: {
                  "tab-code": "rock",
                  title: "Свойства породы",
                  "is-valid": _vm.isRockValid,
                  "is-uploading": _vm.isUploading,
                  description: "Файлы с секциями PERMX, PERMY, PERMZ, PORO",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          { staticClass: "mb-8 input-fields" },
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-text-field", {
                                      ref: "input_cr",
                                      attrs: {
                                        dense: "",
                                        hint: "Сжимаемость породы",
                                        "persistent-hint": "",
                                        type: "number",
                                        min: "0",
                                        rules: _vm.validationRules.gtZero,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "prepend",
                                          fn: function () {
                                            return [
                                              _c("p", [
                                                _vm._v("c"),
                                                _c("sub", [_vm._v("R")]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "append-outer",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._v("бар"),
                                                  _c("sup", [_vm._v("-1")]),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.inputConstants["cr"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.inputConstants,
                                            "cr",
                                            $$v
                                          )
                                        },
                                        expression: "inputConstants['cr']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _vm.permeabilityDefinedInCells
                                      ? _c("v-text-field", {
                                          attrs: {
                                            dense: "",
                                            disabled: "",
                                            value: _vm.meanCellPermeability,
                                            hint: "Средняя проницаемость",
                                            "persistent-hint": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend",
                                                fn: function () {
                                                  return [_vm._v("k")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "append-outer",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [_vm._v("мД")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            361393768
                                          ),
                                        })
                                      : _c("v-text-field", {
                                          ref: "input_k",
                                          attrs: {
                                            dense: "",
                                            hint: "Средняя проницаемость",
                                            "persistent-hint": "",
                                            type: "number",
                                            min: "0",
                                            rules: _vm.validationRules.gtZero,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "prepend",
                                              fn: function () {
                                                return [_vm._v("k")]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "append-outer",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    [_vm._v("мД")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                          model: {
                                            value: _vm.inputConstants["k"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputConstants,
                                                "k",
                                                $$v
                                              )
                                            },
                                            expression: "inputConstants['k']",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _vm.porosityDefinedInCells
                                      ? _c("v-text-field", {
                                          attrs: {
                                            dense: "",
                                            disabled: "",
                                            value: _vm.meanCellPorosity,
                                            hint: "Средняя пористость",
                                            "persistent-hint": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend",
                                                fn: function () {
                                                  return [_vm._v("φ")]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            910298915
                                          ),
                                        })
                                      : _c("v-text-field", {
                                          ref: "input_phi",
                                          attrs: {
                                            dense: "",
                                            hint: "Средняя пористость",
                                            "persistent-hint": "",
                                            type: "number",
                                            min: "0",
                                            rules: _vm.validationRules.gtZero,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "prepend",
                                              fn: function () {
                                                return [_vm._v("φ")]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                          model: {
                                            value: _vm.inputConstants["phi"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.inputConstants,
                                                "phi",
                                                $$v
                                              )
                                            },
                                            expression: "inputConstants['phi']",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.rockFiles,
                  callback: function ($$v) {
                    _vm.rockFiles = $$v
                  },
                  expression: "rockFiles",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "injectionData",
                  title: "История разработки",
                  single: true,
                  "is-valid": _vm.isInjectionDataValid,
                  "is-uploading": _vm.isUploading,
                  "enable-upload": true,
                  description:
                    "Файл должен содержать исторические данные о закачке воды в скважины. Первая строка файла должна содержать названия скважин. Данные должны быть указаны в м<sup>3</sup>/день. У нагнетающих скважин значения должны быть положительные. У добывающих скважин &mdash; отрицательные. В файле должен быть столбец t с обозначением времени измерения в днях от начала наблюдений.",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "grid-table" },
                          [
                            _c("div", [_vm._v("Тип данных:")]),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "mt-0",
                                    attrs: { row: "" },
                                    model: {
                                      value: _vm.injectionDataType,
                                      callback: function ($$v) {
                                        _vm.injectionDataType = $$v
                                      },
                                      expression: "injectionDataType",
                                    },
                                  },
                                  [
                                    _c("v-radio", {
                                      attrs: {
                                        label: "CSV",
                                        value: "csv",
                                        color: "secondary",
                                      },
                                    }),
                                    _c("v-radio", {
                                      attrs: {
                                        label: "Из ГДМ",
                                        value: "hdm",
                                        color: "secondary",
                                        disabled: !_vm.injectionDataHdm,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          !_vm.injectionData &&
                                          _vm.historyOrInjectionError
                                            ? {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "p",
                                                        { staticClass: "ma-0" },
                                                        [_vm._v("Из ГДМ")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ma-0 text--disabled text--small",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.historyOrInjectionError
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("history", {
                              attrs: { wells: _vm.realWells },
                              scopedSlots: _vm._u([
                                {
                                  key: "buttons",
                                  fn: function (ref) {
                                    var rows = ref.rows
                                    var titles = ref.titles
                                    var setRows = ref.setRows
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mb-2 mr-2",
                                          attrs: {
                                            color: "primary",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.fillHistory(
                                                rows,
                                                titles,
                                                setRows,
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Заполнить пустые данные")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.injectionData,
                                callback: function ($$v) {
                                  _vm.injectionData = $$v
                                },
                                expression: "injectionData",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.injectionDataFile,
                  callback: function ($$v) {
                    _vm.injectionDataFile = $$v
                  },
                  expression: "injectionDataFile",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "historyData",
                  title: "История добычи",
                  single: true,
                  "is-valid": _vm.isHistoryDataValid,
                  "is-uploading": _vm.isUploading,
                  "enable-upload": true,
                  description:
                    "Файл должен содержать исторические данные о добыче нефти из скважин. Первая строка файла должна содержать названия скважин. Данные должны быть указаны в м<sup>3</sup>/день. В файле должен быть столбец t с обозначением времени измерения в днях от начала наблюдений",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "grid-table" },
                          [
                            _c("div", [_vm._v("Тип данных:")]),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "mt-0",
                                    attrs: { row: "" },
                                    model: {
                                      value: _vm.historyDataType,
                                      callback: function ($$v) {
                                        _vm.historyDataType = $$v
                                      },
                                      expression: "historyDataType",
                                    },
                                  },
                                  [
                                    _c("v-radio", {
                                      attrs: {
                                        label: "CSV",
                                        value: "csv",
                                        color: "secondary",
                                      },
                                    }),
                                    _c("v-radio", {
                                      attrs: {
                                        label: "Из ГДМ",
                                        value: "hdm",
                                        color: "secondary",
                                        disabled: !_vm.historyDataHdm,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          !_vm.historyDataHdm &&
                                          _vm.historyOrInjectionError
                                            ? {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "p",
                                                        { staticClass: "ma-0" },
                                                        [_vm._v("Из ГДМ")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ma-0 text--disabled text--small",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.historyOrInjectionError
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("history", {
                              attrs: {
                                wells: _vm.realWells,
                                "some-wells": true,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "buttons",
                                  fn: function (ref) {
                                    var rows = ref.rows
                                    var titles = ref.titles
                                    var setRows = ref.setRows
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mb-2 mr-2",
                                          attrs: {
                                            color: "primary",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.fillHistory(
                                                rows,
                                                titles,
                                                setRows
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Заполнить пустые данные")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.historyData,
                                callback: function ($$v) {
                                  _vm.historyData = $$v
                                },
                                expression: "historyData",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.historyDataFile,
                  callback: function ($$v) {
                    _vm.historyDataFile = $$v
                  },
                  expression: "historyDataFile",
                },
              }),
              _c("step", {
                attrs: {
                  "tab-code": "bhpData",
                  title: "История давлений",
                  single: true,
                  "is-valid": _vm.isBhpDataValid,
                  "is-uploading": _vm.isUploading,
                  "enable-upload": true,
                  description:
                    "Файл должен содержать исторические данные о давлениях на скважинах. Первая строка файла должна содержать названия скважин. Данные должны быть указаны в барах. В файле должен быть столбец t с обозначением времени измерения в днях от начала наблюдений.",
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "v-sheet",
                          { staticClass: "grid-table" },
                          [
                            _c("div", [_vm._v("Тип данных:")]),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "mt-0",
                                    attrs: { row: "" },
                                    model: {
                                      value: _vm.bhpDataType,
                                      callback: function ($$v) {
                                        _vm.bhpDataType = $$v
                                      },
                                      expression: "bhpDataType",
                                    },
                                  },
                                  [
                                    _c("v-radio", {
                                      attrs: {
                                        label: "CSV",
                                        value: "csv",
                                        color: "secondary",
                                      },
                                    }),
                                    _c("v-radio", {
                                      attrs: {
                                        label: "Из ГДМ",
                                        value: "hdm",
                                        color: "secondary",
                                        disabled: !_vm.bhpDataHdm,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          !_vm.bhpDataHdm &&
                                          _vm.historyOrInjectionError
                                            ? {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "p",
                                                        { staticClass: "ma-0" },
                                                        [_vm._v("Из ГДМ")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ma-0 text--disabled text--small",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.historyOrInjectionError
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("history", {
                              attrs: { wells: _vm.realWells },
                              scopedSlots: _vm._u([
                                {
                                  key: "buttons",
                                  fn: function (ref) {
                                    var rows = ref.rows
                                    var titles = ref.titles
                                    var setRows = ref.setRows
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mb-2 mr-2",
                                          attrs: {
                                            color: "primary",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.fillHistory(
                                                rows,
                                                titles,
                                                setRows
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Заполнить пустые данные")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.bhpData,
                                callback: function ($$v) {
                                  _vm.bhpData = $$v
                                },
                                expression: "bhpData",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.bhpDataFile,
                  callback: function ($$v) {
                    _vm.bhpDataFile = $$v
                  },
                  expression: "bhpDataFile",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "75%" },
          on: { close: _vm.closeExternalValidate },
          model: {
            value: _vm.externalValidateShow,
            callback: function ($$v) {
              _vm.externalValidateShow = $$v
            },
            expression: "externalValidateShow",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Результаты проверки")]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-expansion-panels",
                    { attrs: { accordion: "", multiple: "" } },
                    [
                      _vm.externalValidateGroups.error.length > 0
                        ? _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "actions",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: "error",
                                                  dark: "",
                                                  small: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.externalValidateGroups
                                                      .error.length
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3649883706
                                  ),
                                },
                                [_vm._v(" Ошибки ")]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-expansion-panels",
                                    { attrs: { accordion: "" } },
                                    _vm._l(
                                      _vm.externalValidateGroups.error,
                                      function (error, index) {
                                        return _c(
                                          "v-expansion-panel",
                                          { key: index },
                                          [
                                            _c(
                                              "v-expansion-panel-header",
                                              {
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "actions",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "error",
                                                                dark: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  error.items
                                                                    .length
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(error.title) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("v-expansion-panel-content", [
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(error.items.join("\n"))
                                                ),
                                              ]),
                                            ]),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.externalValidateGroups.warning.length > 0
                        ? _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "actions",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: "orange",
                                                  dark: "",
                                                  small: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.externalValidateGroups
                                                      .warning.length
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2345531392
                                  ),
                                },
                                [_vm._v(" Предупреждения ")]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-expansion-panels",
                                    { attrs: { accordion: "" } },
                                    _vm._l(
                                      _vm.externalValidateGroups.warning,
                                      function (warning, index) {
                                        return _c(
                                          "v-expansion-panel",
                                          { key: index },
                                          [
                                            _c(
                                              "v-expansion-panel-header",
                                              {
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "actions",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "orange",
                                                                dark: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  warning.items
                                                                    .length
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(warning.title) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("v-expansion-panel-content", [
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(
                                                    warning.items.join("\n")
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v("Полный лог"),
                          ]),
                          _c("v-expansion-panel-content", [
                            _c("pre", [
                              _vm._v(_vm._s(_vm.externalValidateResult)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.closeExternalValidate },
                    },
                    [_vm._v("Закрыть")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-footer",
        [
          _c(
            "v-btn",
            {
              staticClass: "mb-4 mr-2",
              attrs: { color: "primary", text: "", disabled: !_vm.isValid },
              on: { click: _vm.saveModelAndGoToCalc },
            },
            [_vm._v("Сохранить и к адаптации")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "mb-4 mr-2",
              attrs: { color: "primary", text: "" },
              on: { click: _vm.saveModelAndGoToList },
            },
            [_vm._v("Сохранить и к списку")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mb-4 mr-4",
              attrs: { color: "primary", disabled: !_vm.isValid, text: "" },
              on: { click: _vm.downloadJson },
            },
            [_vm._v("Скачать JSON")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "mb-4 mr-4",
              attrs: { color: "primary", disabled: !_vm.isValid, text: "" },
              on: { click: _vm.externalValidate },
            },
            [_vm._v("Проверить расчет")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "mb-4",
              attrs: { color: "primary", loading: _vm.saving, large: "" },
              on: { click: _vm.save },
            },
            [_vm._v("Сохранить модель")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }